module.exports = __webpack_public_path__ + "static/img/hotwindImg2.aa8f4c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotwindImg2.png
// module id = l+T7
// module chunks = 2